import { extractQueryState } from "@shared/utils/extractQueryState";
import { useQuery } from "@tanstack/react-query";
import { getUsersApiClient } from "@shared/apis/sidekick/api-factories";
import { GetMyExtendedProfileResponse } from "@shared/apis/sidekick/generated";

export const GET_USER_PROFILE_QUERY_KEY = "user-profile";

type Props = {
  onSuccess: (data: GetMyExtendedProfileResponse) => void;
  onError?: (error: any) => void;
  onSettled?: () => void;
  enabled?: boolean;
};

export const useGetUserProfile = (props?: Props) => {
  const { enabled = false } = props || {};
  const api = getUsersApiClient();
  const query = useQuery({
    queryKey: [GET_USER_PROFILE_QUERY_KEY],
    queryFn: async () => {
      try {
        const data = await api.userControllerGetExtendedProfile();
        props?.onSuccess(data);
        return data;
      } catch (error) {
        console.error("Failed to get user info.", error);
        props?.onError?.(error);
        throw error;
      } finally {
        props?.onSettled?.();
      }
    },
    enabled,
    retry: 2,
    refetchOnWindowFocus: false,
  });

  return extractQueryState(query);
};
